import React from 'react';
import Skeleton from '../skeleton/skeleton';
import './pagination.scss';

export default function PaginationLoader() {
  return (
    <div className="custom-pagination">
      <Skeleton skHeight="0.833vw" skRadius="0.694vw" skWidth="12.153vw" />
      <div className="paging-block">
        <Skeleton
          skHeight="0.833vw"
          skRadius="0.694vw"
          skWidth="3.472vw"
          marginRight="0.694vw"
        />
        <Skeleton
          skHeight="2.222vw"
          skRadius="0.278vw"
          skWidth="2.222vw"
          marginRight="0.278vw"
        />
        <Skeleton
          skHeight="2.222vw"
          skRadius="0.278vw"
          skWidth="2.222vw"
          marginRight="0.278vw"
        />
        <Skeleton
          skHeight="2.222vw"
          skRadius="0.278vw"
          skWidth="2.222vw"
          marginRight="0.278vw"
        />
        <Skeleton
          skHeight="2.222vw"
          skRadius="0.278vw"
          skWidth="2.222vw"
          marginRight="0.278vw"
        />
        <Skeleton
          skHeight="2.222vw"
          skRadius="0.278vw"
          skWidth="2.222vw"
          marginRight="0.278vw"
        />
      </div>
    </div>
  );
}
